import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { OutboxContext } from "../main";
import userDetail from "Stores/userDetail";
import { outboxStoreData } from "../outboxStore";
import { emailPreviewContentPopupState } from "Components/PreviewPopup/EmailPreviewContentPopup";
import Utils from "Utils/utils";
import DateUtils from "Utils/DateUtils";
import { OutboxUtils } from "Utils/OutboxUtils";
import InboxUtils from "Utils/InboxUtils";
import CheckBox from "Components/common/CheckBox";
import CustomTooltip from "Components/common/CustomTooltip";
import DropDownMenu from "Components/common/DropDownMenu";
import { EmailScheduleDateAndTime } from "../CommonEmailContents";
import { ReactComponent as ContactIcon } from "Assets/svg/outbox/name.svg";
import { ReactComponent as EmailSubjectIcon } from "Assets/svg/outbox/emailSubject.svg";
import { ReactComponent as ContactHoverIcon } from "Assets/svg/outbox/hover/nameHover.svg";
import { ReactComponent as EmailSubjectHoverIcon } from "Assets/svg/outbox/hover/emailSubjectHover.svg";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedInOutlined.svg";
import { observer } from "mobx-react-lite";
import { ContactUtils } from "Utils/ContactUtils";
import { linkedInReplyPopupState } from "Components/PreviewPopup/LinkedInReplyContentPopup";
import makeApi, { URLS } from "Utils/apiURL";
import { toasterState } from "Components/common/toaster";
import SentimentIcon from "Components/common/SentimentIcon";
import BounceTypeBadge from "Components/common/BounceTypeBadge";

const OutboxCard = observer((props = {}) => {
  const {
    inputValues = {},
    setInputValues = () => { },
    getReloadOutboxCardData = () => { },
    openDropdownId = null,
    setOpenDropdownId = () => { }
  } = useContext(OutboxContext);
  const { activeFilter = {} } = inputValues || {};
  const { name = "" } = outboxStoreData?.activeFilter || {};
  const isScheduledorAllFilter = ["all", "scheduled"].includes(
    name?.toLowerCase()
  );

  const {
    contact = {},
    task = {},
    contactOwner = {},
    sequence = {},
    openContactCard = () => { },
    index = 0,
    isChecked = false,
    linkedinAccountId = "",
    isOldLinkedInAccount = false,
    scheduledSequenceId = ""
  } = props || {};

  const {
    id: contactId = "",
    firstName = "",
    lastName = "",
    email: emailAddress = ""
  } = contact?.[0] || {};

  let {
    id = "",
    touchPoint = {},
    status = "",
    taskDue = "",
    sentDate = "",
    replyDate = "",
    order = "",
    subject = "",
    content = "",
    shortContent = content,
    autoReplyType = "",
    customTask = false,
    scheduleCode = "",
    userEdit = false,
    emailEditedDate = "",
    taskType = "",
    replyContent = "",
    sentCount = "",
    openCount = "",
    clickCount = "",
    replyCount = "",
    oneOffEmail = false,
    timelineEmail = false,
    readStatus = "READ",
    important = false,
    sentiment = null,
    bounceType = null
  } = task || {};

  const isImportant = important;

  const emailInsights = {
    sentCount,
    openCount,
    clickCount,
    replyCount
  };

  if (touchPoint != null) {
    subject =
      status?.toLowerCase() === "replied"
        ? touchPoint?.repliedSubject
        : touchPoint?.subject;
    shortContent =
      status?.toLowerCase() === "replied"
        ? replyContent
        : touchPoint?.shortContent;
  }
  const {
    name: sequenceName = "",
    folderId = "",
    shareType = "",
    id: sequenceId = ""
  } = sequence || {};
  const {
    firstName: contactOwnerFirstName = "",
    lastName: contactOwnerLastName = "",
    email: contactOwnerEmail = ""
  } = contactOwner || {};

  const [showHoverCard, setShowHoverCard] = useState(false);
  const [showToolTip, setShowToolTip] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [positionY, setPositionY] = useState(0);

  // Close dropdown if another one is opened
  useEffect(() => {
    if (openDropdownId !== null && openDropdownId !== id) {
      setShowMoreOptions(false);
    }
  }, [openDropdownId, id]);

  const getHTMLContentAsText = (content = "") => {
    const elem = document.createElement("div");
    if (elem) {
      elem.innerHTML = content;
      return elem?.innerText;
    }
  };

  const handleViewEmailContent = (resData = {}, contactData = {}) => {
    const { emailInsights = {} } = contactData || {};
    const {
      id = "",
      touchPoint = {},
      sentDate = "",
      replyDate = "",
      sequenceId = "",
      replyContent = "",
      sequenceName = "",
      order = "",
      taskType = "",
      oneOffEmail = "",
      timelineEmail = "",
      content = "",
      shortContent = "",
      recipientStatus = {},
      contactId = ""
    } = resData || {};
    const {
      fromAddress = "",
      toAddress = "",
      ccAddress = "",
      bccAddress = "",
      subject = "",
      repliedFromAddress = "",
      repliedToAddress = [],
      repliedCcAddress = []
    } = touchPoint || {};
    emailPreviewContentPopupState.setEditorLoading(false);
    emailPreviewContentPopupState.setShowReplyContent(true);
    emailPreviewContentPopupState.setPopupValues({
      taskId: id,
      eventType: "REPLIED",
      pageType: "inbox",
      showViewReplyBtn: false,
      emailData: {
        from: repliedFromAddress
          ? { email: repliedFromAddress }
          : { email: fromAddress },
        to:
          Array.isArray(repliedToAddress) && repliedToAddress.length > 0
            ? InboxUtils.getEmailAddressList(repliedToAddress)
            : InboxUtils.getEmailAddressList(toAddress),
        cc:
          Array.isArray(repliedCcAddress) && repliedCcAddress.length > 0
            ? InboxUtils.getEmailAddressList(repliedCcAddress)
            : InboxUtils.getEmailAddressList(ccAddress),
        bcc: InboxUtils.getEmailAddressList(bccAddress),
        subject: subject || resData?.subject || "--",
        content: replyContent || content || shortContent || ""
      },
      createTs: replyDate || sentDate,
      taskNotes: touchPoint?.notes,
      sequenceId,
      replyContent,
      sequenceName,
      order,
      currentUserEmail: userDetail?.userInfo?.email,
      folderId,
      sequenceShareType: shareType,
      email: "",
      taskType,
      autoEmail: taskType?.toLowerCase() === "email",
      group: "EMAIL",
      emailInsights,
      hideViewReplyBack: true,
      oneOffEmail,
      timelineEmail,
      isEnableReplyFrwd: true,
      pageType: "outboxReply",
      contactId: contactId,
      recipientStatus: recipientStatus
    });
    emailPreviewContentPopupState.setShowPopup(true);
  };

  const viewReply = async (taskId = "") => {
    emailPreviewContentPopupState.setShowPopup(true);
    emailPreviewContentPopupState.setEditorLoading(true);
    if (taskId) {
      const config = {
        url: `${URLS?.outboxPopupContent}/${taskId}`,
        method: "GET"
      };
      let res = await makeApi(config);
      if (res?.data?.statusCode === 403) {
        emailPreviewContentPopupState.setCanViewEmail(false);
        if (res?.data?.subject) {
          handleViewEmailContent(res?.data, { emailInsights });
        }
      } else if (res?.data) {
        handleViewEmailContent(res?.data, { emailInsights });
      }
    } else {
      toasterState.setToastMsg("something went wrong", "failure");
    }
    emailPreviewContentPopupState.setEditorLoading(false);
  };

  const handleOutboxCardClick = outboxId => {
    if (readStatus === "UNREAD" && status?.toLowerCase() === "replied") {
      outboxStoreData.markAsRead(id, getReloadOutboxCardData);
    }
    outboxStoreData.setActiveOutboxId(outboxId);
    if (taskType?.toLowerCase() === "linkedinauto") {
      if (status?.toLowerCase() === "replied") {
        isOldLinkedInAccount
          ? linkedInReplyPopupState.setIsOldLinkedInAccount(true)
          : linkedInReplyPopupState.setIsOldLinkedInAccount(false);
        outboxStoreData.getLinkedInReplyForActivity(
          contactId,
          "",
          scheduledSequenceId,
          linkedinAccountId
        );
      } else {
        return;
      }
    } else {
      if (status?.toLowerCase() === "replied") {
        viewReply(id);
      } else {
        outboxStoreData.setActiveDataInPopup(props);
        outboxStoreData.setOutboxCardPopup(true);
      }
    }
  };

  const handleCheckboxAction = (value = false, type = "") => {
    setInputValues({
      ...inputValues,
      outboxData: {
        ...inputValues.outboxData,
        result: inputValues?.outboxData?.result?.map(item =>
          item?.task?.id === type ? { ...item, isChecked: value } : item
        )
      }
    });
  };

  // Render dynamic column based on active filter
  const renderDynamicColumn = () => {
    const { name = "" } = outboxStoreData?.activeFilter || {};

    if (name === "replied") {
      return (
        <div className="sentimentColumn">
          <SentimentIcon sentiment={sentiment} />
        </div>
      );
    } else if (name === "bounced") {
      return (
        <div className="bounceTypeColumn">
          <BounceTypeBadge bounceType={bounceType} />
        </div>
      );
    }
    // Return empty div with same flex properties to maintain alignment
    return <div className="sentimentColumn" style={{ visibility: 'hidden' }} />;
  };

  const handleMarkAsImportant = (e, fromMenu = false) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const newStatus = !isImportant;

    setInputValues(prev => ({
      ...prev,
      outboxData: {
        ...prev.outboxData,
        result: prev.outboxData.result?.map(item =>
          item?.task?.id === id ? { ...item, task: { ...item.task, important: newStatus } } : item
        )
      }
    }));

    outboxStoreData.markAsImportant(
      id,
      newStatus,
      () => getReloadOutboxCardData(true)
    );
    if (fromMenu) {
      setShowMoreOptions(false);
      setOpenDropdownId(null);
    }
  };

  const handleMarkAsRead = async (e, fromMenu = false) => {
    if (e && e.stopPropagation) e.stopPropagation();

    try {
      const config = {
        url: URLS.markOutboxMailAsRead,
        method: "POST",
        data: {
          taskId: id
        }
      };
      const res = await makeApi(config);
      if (res?.data) {
        if (res?.data?.readStatus === "READ") {
          setInputValues(prev => ({
            ...prev,
            outboxData: {
              ...prev.outboxData,
              result: prev.outboxData.result?.map(item =>
                item?.task?.id === id ? { ...item, task: { ...item.task, readStatus: "READ" } } : item
              )
            }
          }));
          outboxStoreData.getOutboxUnreadCount();
          getReloadOutboxCardData();
        }
      }
    } catch (err) {
      console.error("Error in marking outbox mail as read", err);
      toasterState.setToastMsg("Failed to mark message as read. Please try again", "failure");
    }
    if (fromMenu) {
      setShowMoreOptions(false);
      setOpenDropdownId(null);
    }
  };

  const handleMarkAsUnread = async (e, fromMenu = false) => {
    if (e && e.stopPropagation) e.stopPropagation();

    try {
      const config = {
        url: URLS.markOutboxMailAsUnRead,
        method: "POST",
        data: {
          taskId: id
        }
      };
      const res = await makeApi(config);
      if (res?.data) {
        if (res?.data?.readStatus === "UNREAD") {
          setInputValues(prev => ({
            ...prev,
            outboxData: {
              ...prev.outboxData,
              result: prev.outboxData.result?.map(item =>
                item?.task?.id === id ? { ...item, task: { ...item.task, readStatus: "UNREAD" } } : item
              )
            }
          }));
          outboxStoreData.getOutboxUnreadCount();
          getReloadOutboxCardData();
        }
      }
    } catch (err) {
      console.error("Error in marking outbox mail as unread", err);
      toasterState.setToastMsg("Failed to mark message as unread. Please try again", "failure");
    }
    if (fromMenu) {
      setShowMoreOptions(false);
      setOpenDropdownId(null);
    }
  };

  const emailStatus = OutboxUtils.getEmailStatus(status, scheduleCode);

  const moreOptions = [
    {
      value: isImportant ? "Remove from important" : "Mark as important",
      key: isImportant ? "REMOVE_IMPORTANT" : "MARK_IMPORTANT",
      method: () => handleMarkAsImportant(null, true),
      icon: {
        ele: (
          <i
            className={`fa ${isImportant ? "fa-star" : "fa-star-o"}`}
            style={{ fontSize: "14px", color: isImportant ? "#FEAC2D" : "inherit", cursor: "pointer" }}
          />
        )
      }
    },
    ...(name?.toLowerCase() === "replied" && ["replied", "completed"].includes(status?.toLowerCase()) && readStatus === "UNREAD"
      ? [
        {
          value: "Mark as read",
          key: "MARK_AS_READ",
          method: () => handleMarkAsRead(null, true),
          icon: {
            ele: (
              <i
                className="fa fa-envelope-open"
                style={{ fontSize: "14px", cursor: "pointer" }}
              />
            )
          }
        }
      ]
      : []),
    ...(name?.toLowerCase() === "replied" && ["replied", "completed"].includes(status?.toLowerCase()) && readStatus === "READ"
      ? [
        {
          value: "Mark as unread",
          key: "MARK_AS_UNREAD",
          method: () => handleMarkAsUnread(null, true),
          icon: {
            ele: (
              <i
                className="fa fa-envelope"
                style={{ fontSize: "14px", cursor: "pointer" }}
              />
            )
          }
        }
      ]
      : [])
  ];

  const toggleMoreOptions = (e, arg = false) => {
    Utils.preventDefaultFn(e);
    setPositionY(e?.pageY);
    const newState = arg ? false : !showMoreOptions;
    setShowMoreOptions(newState);
    if (newState) {
      setOpenDropdownId(id);
    } else {
      setOpenDropdownId(null);
    }
  };

  return (
    <>
      <div
        className={`outboxCardWrapper ${readStatus === "UNREAD" && ["replied", "completed"].includes(status?.toLowerCase())
          ? "inboxMailUnread"
          : "inboxMailRead"
          } ${isScheduledorAllFilter ? "" : "adjustWidth"} ${outboxStoreData.activeOutboxId === index ? "isActiveCard" : ""} ${showMoreOptions ? "dropdownOpen" : ""
          }`}
        onMouseEnter={() => setShowHoverCard(true)}
        onMouseLeave={() => setShowHoverCard(false)}
        onClick={() => handleOutboxCardClick(index)}
      >
        <div className="row-left-controls">
          {!isScheduledorAllFilter && (
            <div className="checkboxBtn">
              <CheckBox
                id={id}
                key={id}
                checked={isChecked}
                cbk={handleCheckboxAction}
              />
            </div>
          )}
          <div
            className={`starIcon ${isImportant ? "isImportant" : ""}`}
            onClick={handleMarkAsImportant}
          >
            {isImportant ? (
              <i className="fa fa-star" />
            ) : (
              <i className="fa fa-star-o" />
            )}
          </div>
          <div className="avatarIcon">
            {showHoverCard ? <ContactHoverIcon /> : <ContactIcon />}
          </div>
        </div>
        <div className="recipientInfoSection">
          <div className="recipientInfo">
            <div
              className="flexCenter"
              onClick={event => {
                Utils.preventDefaultFn(event);
                openContactCard(contact?.[0] || {});
              }}
            >
              {Utils.getName(firstName, lastName)}
              {emailAddress && (
                <div
                  className="recipientEmail"
                  title={emailAddress}
                >{`<${emailAddress}>`}</div>
              )}
            </div>
            {contact?.length > 1 && (
              <span className="recipientCount">+{contact?.length - 1}</span>
            )}
          </div>
        </div>
        <div className={`emailInfoWrapper`}>
          {taskType?.toLowerCase() === "linkedinauto" ? (
            touchPoint?.text ? (
              <div className={"subjectIcon"}>
                <span className="liIcon">
                  <LinkedinIcon />
                </span>
              </div>
            ) : (
              <></>
            )
          ) : (
            <div className={"subjectIcon"}>
              {showHoverCard ? <EmailSubjectHoverIcon /> : <EmailSubjectIcon />}
              {userEdit &&
                ["email"].includes(taskType?.toLowerCase()) &&
                emailEditedDate && (
                  <div
                    className="editScheduleDate"
                    onMouseEnter={() => setShowToolTip(true)}
                    onMouseLeave={() => setShowToolTip(false)}
                  >
                    <span className="orangeDot" />
                    {showToolTip && (
                      <CustomTooltip
                        text={`Updated on ${DateUtils.getDateAndMonth(
                          emailEditedDate,
                          false,
                          true
                        )}`}
                        className={`${index === 0 ? "firstCard" : ""}`}
                      />
                    )}
                  </div>
                )}
            </div>
          )}
          <div
            className={`emailInfoCont ${autoReplyType ? "autoReplyTypeCont" : ""
              }`}
          >
            {taskType?.toLowerCase() === "linkedinauto" ? (
              <span className="content" title={touchPoint?.text}>
                {touchPoint?.text || "--"}
              </span>
            ) : autoReplyType ? (
              <>
                {subject && <span className="subject">{subject}</span>}
                {ContactUtils.getAutoReplyDom(autoReplyType)}
              </>
            ) : (
              <>
                <span className="subject">{subject}</span>
                {(shortContent || content) && (
                  <>
                    <span className="seperatorHyphen">-</span>
                    <span className="content">
                      {getHTMLContentAsText(shortContent || content)}
                    </span>
                  </>
                )}
              </>
            )}
          </div>
        </div>

        {/* Dynamic column for sentiment or bounce type */}
        {renderDynamicColumn()}

        <div
          className={`sequenceSection ${customTask || !sequenceName ? "noStyling" : ""
            }`}
          title={sequenceName || ""}
          onClick={e => {
            if (sequenceName) {
              e.stopPropagation();
              props.history.push(OutboxUtils.getSequenceURL(sequence));
            }
          }}
        >
          {sequenceName ? (
            <div className="sequenceNamecont">{sequenceName}</div>
          ) : (
            "--"
          )}
        </div>
        {activeFilter?.id !== "ERROR" ? (
          <EmailScheduleDateAndTime
            taskDue={
              status?.toLowerCase() === "sent"
                ? sentDate
                : status?.toLowerCase() === "replied"
                  ? replyDate || sentDate
                  : taskDue
            }
            emailStatus={emailStatus}
            showHoverCard={showHoverCard}
          />
        ) : (
          <>
            <div className="scheduledDate" />
            <div className="scheduledTime" />
          </>
        )}
        <div className="contactOwner">
          <span className="circleOwner">
            {Utils.getOwnerInitial({
              firstName: contactOwnerFirstName,
              lastName: contactOwnerLastName,
              email: contactOwnerEmail
            })}
          </span>
        </div>
        <div className="outboxMoreOptions">
          <i
            className="material-icons-outlined moreOptionIcon"
            onClick={e => toggleMoreOptions(e)}
          >
            more_vert
          </i>
          {showMoreOptions && (
            <>
              <DropDownMenu
                options={moreOptions}
                selected={""}
                referenceId={id}
                direction="left"
                parentPosition={positionY}
              />
              <div
                className="dropdownMask"
                onClick={e => toggleMoreOptions(e, true)}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
});

export { OutboxCard };
export default withRouter(OutboxCard);
